import { render } from "./switch.vue?vue&type=template&id=9fbd915e&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"

import "./switch.vue?vue&type=style&index=0&id=9fbd915e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fbd915e"]])

export default __exports__